<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body is-titleless is-footerless">
      <b-field label="Search for a Twitter user" class="mt-0">
        <b-autocomplete
            :data="searchData"
            placeholder="e.g. threadis"
            :keep-first="true"
            :open-on-focus="false"
            :loading="isFetching"
            @typing="searchUsers"
            @select="userChosen"
            :style="{ 'width': '400px' }"
            field="screen_name"
            :clearable="true">

          <template v-slot="props">
            <div class="media">
              <div class="media-left">
                <figure class="image is-24x24">
                  <img :src="props.option.image_url" class="is-rounded" :alt="`${props.option.screen_name}`">

                </figure>
              </div>
              <div class="media-content">
                <strong>{{ props.option.name }}</strong>&nbsp;
                <small>@{{ props.option.screen_name }}</small>
              </div>
            </div>
          </template>
        </b-autocomplete>
      </b-field>
    </section>
  </div>
</template>

<script>

import _ from 'lodash'
import tweets from "../../api/tweets"

export default {
  name: "AddTimelineModal",

  data() {
    return {
      isFetching: false,
      searchData: [],
      username: ''
    }
  },
  methods: {
    searchUsers: _.debounce(function (name) {
      this.isFetching = true
      this.searchData = []
      tweets.userSearch(name).then(response => {
        this.isFetching = false
        this.searchData = response.data
      }).catch((error) => {
        this.isFetching = false
        throw error
      })
    }, 500),

    userChosen: function (user) {
      this.$store.commit('addTimeline', user.screen_name)
      this.$parent.close()
      this.$router.push(`/app/timelines/@${user.screen_name}`)
    }

  }
}
</script>

<style lang="scss" scoped>

</style>
